import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ROUTES } from '../../../utils/routes';

type SegmentId = 'opportunities' | 'communicate';

type NavTab = {
  id: SegmentId;
  route: string;
  title: string;
  emojiHtml: string;
  ariaLabel: string;
};

function ProspectingOpportunitiesOwnerNavTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const tabs = useMemo<NavTab[]>(
    () => [
      {
        id: 'opportunities',
        route: ROUTES.PROSPECTING_NEW_OPPORTUNITIES,
        title: 'Nouvelles opportunités',
        emojiHtml: `<span role="img" aria-label="Nouvelles opportunités">📋</span>`,
        ariaLabel: 'Aller à Nouvelles opportunités',
      },
      {
        id: 'communicate',
        route: ROUTES.PROSPECTING_COMMUNICATE,
        title: 'Communication aux propriétaires',
        emojiHtml: `<span role="img" aria-label="Communication aux propriétaires">✉️</span>`,
        ariaLabel: 'Aller à Communication aux propriétaires',
      },
    ],
    [],
  );

  const activeId: SegmentId = pathname.startsWith(ROUTES.PROSPECTING_COMMUNICATE)
    ? 'communicate'
    : 'opportunities';

  return (
    <div className="sticky top-5 z-20 mt-2 mb-6">
      <div className="grid grid-cols-1 overflow-hidden rounded-2xl border border-gray-200/80 bg-gray-100 md:grid-cols-2">
        {tabs.map(tab => {
          const isActive = tab.id === activeId;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => navigate(tab.route)}
              aria-label={tab.ariaLabel}
              aria-current={isActive ? 'page' : undefined}
              className={`flex min-h-24 cursor-pointer flex-col items-center justify-center gap-2 px-6 py-5 transition-all duration-300 hover:-translate-y-0.5 ${
                isActive
                  ? 'border-b-8 border-rgpd-green bg-white font-bold text-slate-800'
                  : 'border-b-4 border-transparent bg-transparent font-semibold text-slate-500'
              }`}
            >
              <span className="text-xl" dangerouslySetInnerHTML={{ __html: tab.emojiHtml }} />
              <span className="text-center leading-relaxed">{tab.title}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default ProspectingOpportunitiesOwnerNavTabs;
